import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    import { Auth0 } from '@/Services/Auth0/auth0-interface'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginButton',
  setup(__props) {

    const auth0: Auth0 | null = useAuth0();

    const login = () => {
        if (!auth0) {
            console.log('Hit !auth0 on Login Button');
            return;
        }
        console.log('Hitting auth0.login');
        auth0.login()

    };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button button--primary button--compact",
    onClick: login
  }, " Log In "))
}
}

})